Librarian.Config = {
    libraryTemplate: null,
    config: null,

    load: function (onComplete) {
        Librarian.Config.chain = new Chain();
        Librarian.Config.chain.chain(
            Librarian.Config.loadConfig,
            Librarian.Config.loadLibraryTemplate,
            Librarian.Config.applyLibraryStyles,
            Librarian.Config.applyLogo,
            function () {
                if (onComplete) {
                    onComplete();
                }

                Librarian.Config.chain.callChain();
            }
        ).callChain();
    },

    loadConfig: function () {
        var url = Librarian.path.getConfigUrl("getbrandingfile") + "&name=LibraryStyles.json";

        new Request.JSON({
            url: url,
            method: "get",
            onSuccess: function (config) {
                Librarian.Config.config = config;
                Librarian.Config.chain.callChain();
            },
            onFailure: function() {
                Librarian.Config.chain.callChain();
            }
        }).send();
    },

    loadLibraryTemplate: function () {
        var url = Librarian.path.getLayoutsPath() + "core/config/libraryTemplate.css";

        if (Librarian.config.customStylesheet) {
            url = Librarian.config.customStylesheet;
        }

        var request = new Request({
            url: url,
            method: "get",
            format: "text",
            onSuccess: function (template) {
                Librarian.Config.libraryTemplate = template;
                Librarian.Config.chain.callChain();
            },
            onFailure: function () {
                Librarian.Config.chain.callChain();
            }
        });

        request.send();
    },

    applyLibraryStyles: function () {
        var libraryCss = Librarian.Config.libraryTemplate;
        var libraryStyles = Librarian.Config.config;

        if (libraryCss != null && libraryStyles != null) {
            Object.each(libraryStyles, function (val, key) {
                var placeHolder = "\\[" + key + "\\]";
                var regEx = new RegExp(placeHolder, "g");
                libraryCss = libraryCss.replace(regEx, val);
            });

            var id = "library-branding-css";
            var css = document.getElementById(id);

            if (css != null) {
                css.remove();
            }

            css = document.createElement("style");
            css.type = "text/css";
            css.id = "library-branding-css";
            if ("textContent" in css)
                css.textContent = libraryCss;
            else
                css.innerText = libraryCss;
            document.body.appendChild(css);
        }

        Librarian.Config.chain.callChain();
    },

    applyLogo: function () {
        var url = Librarian.path.getConfigUrl("getbrandingfile") + "&name=LibraryLogo";

        // Library Logo
        var headerLogoEl = $("headerLogo");
        if (headerLogoEl != null) {
            headerLogoEl.set("src", url);
        }
   
        //Login Logo
        var loginHeaderLogoEl = $(document.body).getElement(".header img");
        if (loginHeaderLogoEl != null) {
            loginHeaderLogoEl.set("src", url);
        }

        Librarian.Config.chain.callChain();
    }
};